import { parseISO } from 'date-fns';
import type { TFunction } from 'i18next';
import {
  resolveSpeciesLabel,
  type PatientOptionItem,
} from '@/api/patientOptions/patientOptionsApi';
import { formatDateToDayMonthYear } from '@/utils/dateFormatting';

export type PetChangeRequestFieldName = 'name' | 'species' | 'breed' | 'sex' | 'dateOfBirth';

export const PET_CHANGE_REQUEST_FIELD_ORDER: PetChangeRequestFieldName[] = [
  'name',
  'species',
  'breed',
  'sex',
  'dateOfBirth',
];

export function petChangeRequestFieldLabel(
  fieldName: PetChangeRequestFieldName,
  t: TFunction
): string {
  if (fieldName === 'name') {
    return t('patients:form.name');
  }
  if (fieldName === 'species') {
    return t('patients:form.species');
  }
  if (fieldName === 'breed') {
    return t('patients:form.breed');
  }
  if (fieldName === 'sex') {
    return t('patients:form.sex');
  }
  return t('patients:form.dateOfBirth');
}

export function formatPetChangeRequestFieldValue(
  fieldName: PetChangeRequestFieldName,
  value: string | null | undefined,
  t: TFunction,
  speciesOptions: PatientOptionItem[]
): string {
  if (value === undefined || value === null || value.trim().length === 0) {
    return t('patients:detail.notRecorded');
  }
  if (fieldName === 'species') {
    return resolveSpeciesLabel(speciesOptions, value);
  }
  if (fieldName === 'sex') {
    return t('common:sex.' + value);
  }
  if (fieldName === 'dateOfBirth') {
    return formatDateToDayMonthYear(parseISO(value));
  }
  return value;
}
